<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <div :class="getClassName + 'PreviewContainer'">
      <appPreview2D :visible="visibleClass2D"></appPreview2D>
      <appPreview3D :visible="visibleClass3D"></appPreview3D>
    </div>
    <div :class="getClassName + 'ButtonsContainer'">
      <appPacking3dButtons :class="visibleClass3D"></appPacking3dButtons>
      <div :class="getClassName + 'ActionsContainer'">
        <button
          type="button"
          class="btn btn-primary"
          :class="[getClassName + 'Button', visibleClass2D]"
          @click="togglePreview(false)"
        >
          2D
        </button>
        <button
          type="button"
          class="btn btn-primary"
          :class="[getClassName + 'Button', visibleClass3D]"
          @click="togglePreview(true)"
        >
          3D
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { usePreview3DStore } from "@/stores/modules/preview3D";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    visibleClass2D: function () {
      return this.preview3D ? "" : "visible";
    },
    visibleClass3D: function () {
      return this.preview3D ? "visible" : "";
    }
  },
  methods: {
    ...mapActions(usePreview3DStore, ["setActivePreview"]),
    togglePreview: function (value) {
      this.preview3D = value;
      this.setActivePreview(value ? "preview3D" : "preview2D");
    }
  },
  data: function () {
    return {
      preview3D: true
    };
  }
};
</script>
